import type { FC } from 'react';
import React, { useState, useCallback } from 'react';
import { useRifm } from 'rifm';
import type { TChangeEventHandler, TFocusEventHandler } from '@alfa-bank/site-input/models';

import { formatDate } from './helpers';
import type { TBirthdayField, TMouse } from './models';

export const BirthdayField: FC<TBirthdayField> = ({
    BaseInput,
    formatHint = 'дд.мм.гггг',
    onBlur,
    onCancel,
    onChange,
    onFocus,
    separator,
    styles,
    value = '',
    ...rest
}) => {
    const [showHint, setHintVisibility] = useState(false);

    const handleFocus: TFocusEventHandler = useCallback(
        obj => {
            onFocus?.(obj);
            setHintVisibility(true);
        },
        [onFocus]
    );

    const handleBlur: TFocusEventHandler = useCallback(
        obj => {
            onBlur?.(obj);
            setHintVisibility(false);
        },
        [onBlur]
    );

    const rifm = useRifm({
        accept: /\d/g,
        format: newValue => formatDate(newValue, separator),
        mask: value.length >= 10,
        onChange: newValue => {
            onChange?.(newValue);
        },
        value,
    });

    const handleChange: TChangeEventHandler = useCallback(
        obj => {
            rifm.onChange(obj.event);
        },
        [rifm]
    );

    const handleCancel: TMouse = useCallback(
        obj => {
            onCancel?.(obj);
            onChange?.('');
        },
        [onCancel, onChange]
    );

    return (
        <div className={styles.wrapper}>
            {showHint && (
                <div className={styles.hintWrapper}>
                    <span className={styles.hintHidden}>{rifm.value}</span>
                    {formatHint.slice(value.length)}
                </div>
            )}
            <BaseInput
                {...rest}
                onBlur={handleBlur}
                onCancel={handleCancel}
                onChange={handleChange}
                onFocus={handleFocus}
                type="tel"
                value={rifm.value}
            />
        </div>
    );
};
